module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/security-code-c33e7757ae86b3352ea3ede801d15f7e.svg";